/*
	One question, asked by every catch that toasts: is this Error one WE threw, carrying text
	written for a user -- or one the platform threw, whose message is a browser string?

	`error.message ? error.message : fallback` cannot answer it. That guards **emptiness**, never
	provenance: a platform message is non-empty like any other, so it is shown verbatim. The user
	sees "Failed to fetch" or "Unexpected end of JSON input" where a written sentence belongs
	(ha-617).

	The two platform classes that actually reach these catches, both found by RUNNING the guard
	against real error objects rather than reading it:

		TypeError     fetch rejects with it when the connection dies
		              toasted verbatim as: Failed to fetch
		SyntaxError   response.json() throws it on a non-JSON body
		              toasted verbatim as: Failed to execute 'json' on 'Response':
		              Unexpected end of JSON input

	Both strings above are what Chromium actually put on screen, read off the toast while driving
	ha-617 -- not what the spec says. The SyntaxError one is worth quoting in full because it is
	the longer, more alarming wording; the bare "Unexpected end of JSON input" is Node's.

	The list is short and specific on purpose -- it is not a denylist of everything imaginable.
	Adding a class here wants the same evidence the first two had: a path that actually throws it
	into a toasting catch.

	**This is the second line of defence, not the first.** Where a parse can throw, guard the parse
	(`.json().catch(() => undefined)`) and throw your own sentence -- that gives the user correct
	advice instead of a generic retry. This function catches what the guards miss.

	Returns undefined when the caller should use its own written fallback.
*/
export function userFacingErrorMessage(error: unknown): string | undefined {
	if (!(error instanceof Error))
		return undefined
	if (error instanceof TypeError || error instanceof SyntaxError)
		return undefined
	return error.message || undefined
}
